import Service from "../Service";
import Vue from "vue";

const resource = "TicRequirementsRequest/";

export default {
    save(cmp, requestID) {
        return Service.post(resource + "save", cmp, {
            params: { requestID: requestID },
        });
    },

    pagination(parameters, requestID) {
        return Service.post(resource + "pagination", parameters, {
            params: { requestID: requestID },
        });
    },

    getUrlTaskProject() {
        return Vue.prototype.$http.defaults.baseURL + "/TicRequirementsRequest/TaskProject";
    },
    
};